"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

export function LearningCenterChrome({ children, navigation, footer, compactFooter }: {
  children: ReactNode;
  navigation: ReactNode;
  footer: ReactNode;
  compactFooter: ReactNode;
}) {
  const pathname = usePathname();
  const isWalkthrough = pathname === "/learning-center/watch/kalshi-college-football" || pathname === "/learning-center/watch/kalshi-math" || pathname === "/learning-center/watch/kalshi-whales" || pathname === "/learning-center/watch/price-first";
  const isBio = pathname === "/learning-center/bio" || pathname === "/learning-center/bio/tj" || pathname === "/learning-center/bio/alex" || pathname === "/learning-center/bio/upside";
  const hasWideHero = pathname?.startsWith("/learning-center/explain/") || pathname === "/learning-center/proof";
  const isExplanation = pathname?.startsWith("/learning-center/explain/") || pathname === "/learning-center/proof" || pathname === "/learning-center/plan";

  return (
    <>
      {isBio || isWalkthrough ? null : isExplanation ? (
        <header className={`mx-auto flex max-w-3xl items-center border-b border-border px-5 py-4 sm:px-8 ${hasWideHero ? "lg:max-w-[1440px] lg:px-12" : ""}`}>
          <a href="/" className="text-xl font-bold tracking-tight text-foreground" aria-label="Upside home">upside<span className="text-primary">.</span></a>
        </header>
      ) : navigation}
      <main className={isExplanation ? "min-h-[70vh]" : "min-h-screen"}>{children}</main>
      <div className="landing-grain" aria-hidden="true" />
      {isExplanation || isBio || isWalkthrough ? compactFooter : footer}
    </>
  );
}
